// extracted by mini-css-extract-plugin
export default {"control":"control_control__fjHaO","button":"control_button__R7034"};